import React from 'react';
import './informal_videos.css';
const informal_videos = [
  {
    id: 'https://www.youtube.com/embed/5ud83AlrbKY?si=_O1PsnQdkk6865gC',
    title: 'S02 Episode 2 (Aug 28, 2022) — Prof. J. V. Naralikar',
    thumbnail: 'https://img.youtube.com/vi/5ud83AlrbKY/hqdefault.jpg',
    description:
      'In this episode, Prof. J. V. Naralikar shares his insights on cosmology and scientific thinking as part of the IYNS Series.',
  },
  {
    id: 'https://www.youtube.com/embed/oQDV3DzjYuQ?si=r723hQ43_6hFW6Ty',
    title: 'S02 Episode 1 (July 31, 2022) — Prof. J. B. Joshi',
    thumbnail: 'https://img.youtube.com/vi/oQDV3DzjYuQ/hqdefault.jpg',
    description:
      'Prof. J. B. Joshi discusses nuclear chemistry, innovation, and the evolution of India’s scientific ecosystem.',
  },
  {
    id: 'https://www.youtube.com/embed/USnTQDpnxr8?si=GPYfY6Q_F_ymPPpq',
    title: 'S01 Episode 08 (March 28, 2021) — Dr. Archana Sharma',
    thumbnail: 'https://img.youtube.com/vi/USnTQDpnxr8/hqdefault.jpg',
    description:
      'Featuring Dr. Archana Sharma from CERN, this episode explores particle physics, research, and youth in science.',
  },
  {
    id: 'https://www.youtube.com/embed/ysWuliugPD4?si=vwDY7LTbT4WeQL3K',
    title: 'S01 Episode 07 (Jan 31, 2021) — Shri K. N. Vyas',
    thumbnail: 'https://img.youtube.com/vi/ysWuliugPD4/hqdefault.jpg',
    description:
      'Shri K. N. Vyas discusses India’s nuclear energy initiatives and future opportunities for young scientists.',
  },
  {
    id: 'https://www.youtube.com/embed/TZtHDMkakc8?si=0YnDVO1SYXkME-uS',
    title: 'S01 Episode 06 (Dec 27, 2020) — Mid-Season Special',
    thumbnail: 'https://img.youtube.com/vi/TZtHDMkakc8/hqdefault.jpg',
    description:
      'A special mid-season feature reflecting on key insights from the IYNS “From Fission to Future” series.',
  },
  {
    id: 'https://www.youtube.com/embed/okgug-xhSeY?si=K71QXrnbDc4DO0jl',
    title: 'S01 Episode 05 (Nov 29, 2020) — Dr. D. K. Aswal',
    thumbnail: 'https://img.youtube.com/vi/okgug-xhSeY/hqdefault.jpg',
    description:
      'Dr. D. K. Aswal talks about advances in material science and its applications in nuclear energy.',
  },
  {
    id: 'https://www.youtube.com/embed/q9nnsl7UZCM?si=63EkyefWc9CSUiYq',
    title: 'S01 Episode 04 (Oct 25, 2020) — Dr. Ravi B. Grover',
    thumbnail: 'https://img.youtube.com/vi/q9nnsl7UZCM/hqdefault.jpg',
    description:
      'Dr. Ravi B. Grover discusses India’s nuclear journey, education, and the role of technology in sustainable growth.',
  },
  {
    id: 'https://www.youtube.com/embed/MiXYjqJxdD4?si=8LJ9tLO4lCP2651G',
    title: 'S01 Episode 03 (Sep 27, 2020) — Dr. R. Chidambaram',
    thumbnail: 'https://img.youtube.com/vi/MiXYjqJxdD4/hqdefault.jpg',
    description:
      'Dr. R. Chidambaram, former Principal Scientific Adviser, explores the importance of nuclear research and collaboration.',
  },
  {
    id: 'https://www.youtube.com/embed/BTs-hKRMVdg?si=JVDW7QZbh7AJ5Kd1',
    title: 'S01 Episode 02 (Aug 30, 2020) — Dr. Srikumar Banerjee',
    thumbnail: 'https://img.youtube.com/vi/BTs-hKRMVdg/hqdefault.jpg',
    description:
      'Dr. Srikumar Banerjee discusses the evolution of India’s nuclear program and the pursuit of scientific excellence.',
  },
  {
    id: 'https://www.youtube.com/embed/MlYyvkm3U7o?si=xjLevy2J7D0S7w60',
    title: 'S01 Episode 01 (July 26, 2020) — Dr. Anil Kakodkar',
    thumbnail: 'https://img.youtube.com/vi/MlYyvkm3U7o/hqdefault.jpg',
    description:
      'Dr. Anil Kakodkar opens the IYNS series with insights into India’s nuclear development and sustainable innovation.',
  },
];

function InformalVideos() {
  return (
    <div>
      <div className="youtube-videos">
        <p className="title-text-black">YouTube Videos</p>
        <a
          className="website-exit-link"
          href="https://www.youtube.com/watch?v=MlYyvkm3U7o&list=PLvzK-4TYf7PE_WuHjFcamGtRwoAdMH0LQ&index=1"
        >
          Watch Youtube Videos
        </a>
      </div>
      <div className="video-grid">
        {informal_videos.map((video) => (
          <div className="video-container">
            <div className="video-card">
              <a href={video.id} target="_blank" rel="noopener noreferrer">
                <iframe src={video.id} height="200" width="350" title="Youtube"></iframe>
              </a>
              <div className="video-name-and-desc">
                <p className="video-name">{video.title}</p>
                <p className="video-desc">{video.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default InformalVideos;
